<template>
    <div class="newsitem-vertical-container" @click="toViewDetail">
        <ImageCard :src="newsInfo.cover" class="img-card" />
        <div class="newsitem-content">{{ newsInfo.title }}</div>
    </div>
</template>

<script>
    import ImageCard from "@/components/ImageCard"
    export default {
        props:{
            newsInfo:{
                type:Object,
                default:()=>{}
            }
        },
        components:{ ImageCard },
        data() {
            return {}
        },
        methods:{
            toViewDetail() {
                this.$emit('toViewDetail', this.newsInfo)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/var.less";
    @import "~@/styles/mixin.less";
    .newsitem-vertical-container {
        width: 250px;
    }
    .img-card {
        cursor: pointer;
    }
    .newsitem-content{
        width: 250px;
        font-size: 14px;
        font-weight: 600;
        color: @words;
        line-height: 20px;
        cursor: pointer;
        .line-clamp()
    }
</style>